import React from "react";
import PasswordSuccessPage from "./passwordSuccess.jsx"
import { useHistory } from "react-router";

const PassSuccess = () => {
  const history = useHistory();
  const handleSubmit = () => {
    localStorage.removeItem("flowName")
    localStorage.removeItem("token");
    localStorage.removeItem("customerId");
    localStorage.removeItem("email");

    localStorage.removeItem("instituteUSER");

    localStorage.removeItem("requestType");
    localStorage.removeItem("flowType")

    history.push("/");
    window.location.reload()
  }
  const onBackClick = () => {
    history.goBack()
  }
      return (
        <div>
          <PasswordSuccessPage
            handleSubmit={handleSubmit}
            onBackClick={onBackClick}
          />
        </div>
      );
    
  }
  
  export default PassSuccess;
  